import {route} from "ziggy-js";
import {trackEvent} from "../tracking/gtm";

const DECODE_FORM_VIN_BUTTON = 'js-decode-vin-form-button';
const DECODE_VIN_FORM_INPUT = 'js-decode-vin-input';
const MINIMUM_VIN_LENGTH = 17;
const MISSING_CHARACTERS = 'missing-characters';

document.addEventListener('DOMContentLoaded', initDecodeWidget);

/**
 * Initializes Decode Widget by setting up the modal and adding event listeners.
 */
function initDecodeWidget() {
    const vinFormButtons = document.querySelectorAll(`.${DECODE_FORM_VIN_BUTTON}`);
    if (!vinFormButtons.length) return;

    // Input validation
    let decodeVinInputs = document.getElementsByClassName(DECODE_VIN_FORM_INPUT);
    Array.from(decodeVinInputs).forEach(input =>
        input.addEventListener('input', validateDecodeInput)
    );

    vinFormButtons.forEach(button =>
        button.addEventListener('click', handleVinFormButtonClick)
    );
}

/**
 * Prevent form submit, redirect to decode route.
 */
function handleVinFormButtonClick(e) {
    e.preventDefault();
    const vin = document.querySelector(`.${DECODE_VIN_FORM_INPUT}`).value;

    trackEvent("vin_entered", {vin});

    window.location.href = route("decode.vin", {vin});
}

/**
 * Uppercase, strip invalid chars, toggle button & missing count.
 */
function validateDecodeInput(e) {
    const input = e.target;
    let vin = input.value.replace(/\s/g, '').toUpperCase()
        .replace(/[^0-9A-Z]/g, '')
        .replace(/I/g, '1').replace(/O/g, '0').replace(/Q/g, '0');
    input.value = vin;

    const missingEl = input.parentNode.querySelector(`.${MISSING_CHARACTERS}`);
    const buttons = document.querySelectorAll(`.${DECODE_FORM_VIN_BUTTON}`);
    buttons.forEach(btn => btn.disabled = vin.length < MINIMUM_VIN_LENGTH);

    if (missingEl) {
        missingEl.textContent = `${-MINIMUM_VIN_LENGTH + vin.length}`;
    }
}
